module.exports = __webpack_public_path__ + "img/spiral-dough-top-down.2f3f7f70.svg";